module.exports = __webpack_public_path__ + "files/2e6c12717289353fe54c922871edd5d0.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/solarized-dark.png
// module id = 928
// module chunks = 76